
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import BlueButton from './Atomic/BlueButton.vue'
import GreenButton from './Atomic/GreenButton.vue'
import RedButton from './Atomic/RedButton.vue'
import CardTitle from './Atomic/CardTitle.vue'
import Role from '../models/role'
import { PermissionService } from '../services/permissionService'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
    ProgressLinear,
  },
})
export default class CreateRole extends Vue {
  public dialog: boolean = false
  public isPending: boolean = false
  public role: Role
  public permissionService: PermissionService

  @Prop(Function) public readonly create!: (role: Role) => void
  @Prop(Boolean) public readonly reset!: boolean

  constructor() {
    super()
    this.initialize()
  }

  private async save() {
    this.isPending = true
    const validated = await this.$validator.validateAll()
    if (validated) {
      await this.create(this.role)
      this.dialog = false
      this.initialize()
    }
    this.isPending = false
  }

  private initialize() {
    this.isPending = false
    this.role = new Role(-1, '', '', [1], -2)
    this.$validator.reset()
  }

  private cancel() {
    this.initialize()
    this.$validator.reset()
    this.dialog = false
  }
}
